/**
 * BaseTemplateInternational
 *
 * Misma UI que BaseTemplateBlack (home internacional). Los CTAs del hero
 * (wishlist, comunidad, cumpleaños) salen de `getServerTemplateConfig()` →
 * `window.__TEMPLATE_CONFIG__` inyectado por el Cloudflare Worker.
 * `heroCta` opcional: cuando el admin habilita el override en /admin/site-settings,
 * el Worker lo resuelve y lo pasa al cliente (Index.tsx) que lo inyecta acá.
 *
 * Override de analytics: reporta `template_type = "BaseTemplateInternational"`
 * y `region` real (US/SPAIN/LATAM) derivada del país detectado por el Worker,
 * para poder filtrar la variante internacional en PostHog/GA/FB Pixel.
 */

import type { FC } from "react";
import {
  BaseTemplateBlack as BaseTemplate,
  type TemplateProps,
} from "@/components/templates/BaseTemplateBlack";
import { getServerTemplateConfig } from "@/lib/serverTemplateDetection";

type BaseTemplateInternationalProps = Omit<
  TemplateProps,
  "analyticsTemplateName" | "analyticsRegion"
>;

/** Mismo mapeo que `useTemplateSelection` → `seoRegionFromCountry`. */
function regionFromCountry(country: string | undefined | null): string {
  if (country === "US") return "US";
  if (country === "ES") return "SPAIN";
  return "LATAM";
}

export const BaseTemplateInternational: FC<BaseTemplateInternationalProps> = (
  props,
) => {
  const region = regionFromCountry(getServerTemplateConfig()?.country);
  return (
    <BaseTemplate
      {...props}
      analyticsTemplateName="BaseTemplateInternational"
      analyticsRegion={region}
    />
  );
};
